import { Decoration, DecorationSet } from "prosemirror-view"
import { Plugin, TextSelection } from "prosemirror-state"
import { Node } from 'prosemirror-model'
import { faWarning } from "@fortawesome/pro-solid-svg-icons"
import {icon as faIcon, IconDefinition } from'@fortawesome/fontawesome-svg-core';

export interface TemplateErrors {
    msg: string,
    from: number,
    to: number
}

// Words you probably shouldn't use
const badWords = /\b(obviously|clearly|evidently|simply)\b/ig
// Matches punctuation with a space before it
const badPunc = / ([,\.!?:]) ?/g

const emptyTemplate = /\[(.*?)\]/g

function lint(doc: Node) {
    let result: TemplateErrors[] = [], lastHeadLevel = null

    function record(msg: string, from: number, to: number) {
        result.push({ msg, from, to })
    }

    // For each node in the document
    doc.descendants((node: Node, pos: number) => {
        if (node.isText) {
            // Scan text nodes for suspicious patterns
            let m
            // while (m = badWords.exec(node.text ?? ""))
            //     record(`Try not to say '${m[0]}'`,
            //         pos + m.index, pos + m.index + m[0].length)

            // while (m = badPunc.exec(node.text ?? ""))
            //     record("Suspicious spacing around punctuation",
            //         pos + m.index, pos + m.index + m[0].length)

            while (m = emptyTemplate.exec(node.text ?? "")) {
                record("Unfilled template data",
                    pos + m.index, pos + m.index + m[0].length)
            }
        } 
    })

    return result
}


function lintDeco(doc: Node) {
    let decos: Decoration[] = []
    lint(doc).forEach(prob => {
        decos.push(Decoration.inline(prob.from, prob.to, { class: "problem" }),
            Decoration.widget(prob.from, lintIcon(prob)))
    })
    return DecorationSet.create(doc, decos)
}

function lintIcon(prob: TemplateErrors) {
    let icon = document.createElement("div");
    icon.innerHTML = faIcon(faWarning).html.join("")
    icon.className = "lint-icon";
    icon.title = prob.msg;
    (icon as any).problem = prob
    return icon
}

let emailTemplateLinter = new Plugin({
    state: {
        init(_, { doc }) { return lintDeco(doc) },
        apply(tr, old) { return tr.docChanged ? lintDeco(tr.doc) : old }
    },
    props: {
        decorations(state) { return this.getState(state) },
        handleClick(view, _, event: any) {
            if (/lint-icon/.test(event.target.className ?? "")) {
                let { from, to } = event.target.problem
                view.dispatch(
                    view.state.tr
                        .setSelection(TextSelection.create(view.state.doc, from, to))
                        .scrollIntoView())
                return true
            }
            return true
        },
        handleDoubleClick(view, _, event: any) {
            // if (/lint-icon/.test(event.target.className ?? "")) {
            //     let prob = event.target.problem
            //     if (prob.fix) {
            //         prob.fix(view)
            //         view.focus()
            //         return true
            //     }
            //     return false
            // }
            // return false
        }
    }
})

export default emailTemplateLinter